import { FETCH_RECENT_ORDERS, FETCH_RECENT_ORDERS_SUCCESS, FETCH_RECENT_ORDERS_FAILURE } from '../actions';

const initialState = {
  recentOrders: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_RECENT_ORDERS:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_RECENT_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        recentOrders: action.data
      };
    case FETCH_RECENT_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        recentOrders: []
      };
    default:
      return state;
  }
}